import { createAsyncThunk } from "@reduxjs/toolkit";
import { DeleteUsersParams, DeleteUsersResponse } from "api/api/usersApi/types";
import { UsersAPI } from "api/api/usersApi/usersApi";
import axios from "axios";

export const deleteUsers = createAsyncThunk<DeleteUsersResponse, DeleteUsersParams>(
  "users/deleteUsers",
  async ({ userId, ...params }, { rejectWithValue }) => {
    try {
      const response = await UsersAPI.deleteUsers({ userId, ...params });
      return response.data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error("Error while deleting user details", error.response?.data);
        return rejectWithValue(error.response?.data || "Unknown error");
      }
      else {
        console.error("Error while deleting user details", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);